<template>
  <template v-if="isAiNpc">
    <!-- 起動 FAB（AppBar 相当・全 AiNpc ページ常駐） -->
    <v-btn
      v-if="!store.open"
      class="assistant-fab"
      color="primary"
      icon="mdi-robot-happy-outline"
      size="large"
      elevation="6"
      @click="store.open = true"
    />

    <!-- 右スライドインの固定パネル（バックドロップ無し・本体は左に寄って操作可能） -->
    <transition name="assistant-slide">
      <div v-if="store.open" class="assistant-dock">
        <AiNpcAssistantPanel :context="context" @close="store.open = false" />
      </div>
    </transition>
  </template>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import AiNpcAssistantPanel from "@/components/AiNpcAssistantPanel.vue";
import { useAiNpcAssistantStore } from "@/stores/aiNpcAssistantStore";

const route = useRoute();
const store = useAiNpcAssistantStore();

const isAiNpc = computed(() => !!route.meta?.requiresAiNpc);

// route から現在のタブと対象 id を推定する。
const context = computed(() => {
  const name = route.name || "";
  const id = route.params?.id;
  let tab = "scenarios";
  if (name.includes("ConversationLog")) tab = "conversation_logs";
  else if (name.includes("Knowledge")) tab = "knowledge";
  else if (name.includes("Personality") || name === "AiNpcView") tab = "personalities";
  else if (name.includes("Scenario")) tab = "scenarios";
  return { tab, objectId: id };
});
</script>

<style scoped>
.assistant-fab {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1900;
}
.assistant-dock {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 440px;
  max-width: 94vw;
  z-index: 2000;
  background: rgb(var(--v-theme-surface));
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.assistant-slide-enter-active,
.assistant-slide-leave-active {
  transition: transform 0.25s ease;
}
.assistant-slide-enter-from,
.assistant-slide-leave-to {
  transform: translateX(100%);
}
</style>
